/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { isNumber, isString } from 'remeda'
import styled, { css } from 'styled-components'
import type { TextProps } from './SansText.types'

export const Text = styled.p<TextProps>`
  font-family: ${({ theme }) => {
    return theme.fonts.brand
  }};
  letter-spacing: 0;
  font-weight: ${({ fontWeight }) => {
    return fontWeight ?? '400'
  }};
  font-style: ${({ fontStyle }) => {
    return fontStyle ?? 'normal'
  }};
  margin: ${({ margin }) => {
    if (isNumber(margin)) {
      return `${margin}px`
    }

    if (isString(margin)) {
      return margin
    }

    return '0'
  }};
  padding: ${({ padding }) => {
    if (isNumber(padding)) {
      return `${padding}px`
    }

    if (isString(padding)) {
      return padding
    }

    return '0'
  }};

  line-height: ${({ leading }) => {
    return leading === 'loose' ? '170%' : '125%'
  }};

  ${({ underline }) => {
    return (
      underline &&
      css`
        text-decoration: underline;
      `
    )
  }}

  ${({ uppercase }) => {
    return (
      uppercase &&
      css`
        text-transform: uppercase;
      `
    )
  }}

  ${({ strikethrough }) => {
    return (
      strikethrough &&
      css`
        text-decoration: line-through;
        text-decoration-thickness: 1px;
      `
    )
  }}

  ${({ center }) => {
    return (
      center &&
      css`
        text-align: center;
      `
    )
  }}

  ${({ theme, color }) => {
    switch (color) {
      case 'inherit': {
        return css`
          color: inherit;
        `
      }
      case 'primary': {
        return css`
          color: ${theme.colors.primary};
        `
      }
      case 'light': {
        return css`
          color: ${theme.colors.primaryLight};
        `
      }
      case 'white': {
        return css`
          color: ${theme.colors.text.secondary};
        `
      }
      case 'gray': {
        return css`
          color: ${theme.colors.hover};
        `
      }
      case 'error': {
        return css`
          color: ${theme.colors.danger};
        `
      }
      default: {
        return css`
          color: ${theme.colors.text.primary};
        `
      }
    }
  }}

  ${({ size }) => {
    switch (size) {
      case 'xs': {
        return css`
          font-size: 9px;
        `
      }
      case 'sm': {
        return css`
          font-size: 12px;
        `
      }
      case 'md': {
        return css`
          font-size: 16px;
        `
      }
      case 'lg': {
        return css`
          font-size: 18px;
        `
      }
      case 'xl': {
        return css`
          font-size: 20px;
        `
      }
      default: {
        return css`
          font-size: 14px;
        `
      }
    }
  }}

  ${({ cursor }) => {
    return (
      cursor &&
      css`
        cursor: ${cursor};
      `
    )
  }}

    b,
    strong {
    font-weight: 500;
  }

  p {
    font-size: inherit;
    line-height: inherit;
    margin-bottom: 0;

    a,
    span {
      text-decoration: underline;
      color: ${({ theme }) => {
        return theme.colors.primary
      }};
    }
  }

  a {
    /* TODO: SHOP-2094 */
    /* Reset anchor <a> styles coming from index.css */
    font-size: inherit;
    line-height: inherit;
    text-decoration: underline;
    color: ${({ theme }) => {
      return theme.colors.primary
    }};
  }
`
